export default __webpack_public_path__ + "static/media/8.c4b485b5.jpg";